import React from "react";
import { IconButton } from "features/../../../shared/components/buttons";
import { ModalBuilder } from "@redriver/cinnamon";
import { deleteRollWidth } from "./actions";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {Actions, Targets} from "features/../../../shared/constants/permissions";
import { TranslatedModal } from "../../../../components/modals";

const DeleteRollWidth = ({
  as: As = IconButton,
  onSubmitted,
  rollWidth,
  ...props
}) => (
  <PermissionCheck target={Targets.LargeFormat} action={Actions.Delete}>
    <ModalBuilder
      submitAction={deleteRollWidth}
      submitParams={rollWidth.id}
      onSubmitted={onSubmitted}
      renderTrigger={showModal => (
        <As onClick={showModal} {...props}>
          Delete
        </As>
      )}
      renderModal={modalProps => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header="Delete Roll Width"
          submitLabel="Delete Roll Width"
        >
          <p>Are you sure that you wish to remove this item?</p>
        </TranslatedModal.Confirmation>
      )}
    />
  </PermissionCheck>
);

export default DeleteRollWidth;
